import type { FC } from 'react';

export const CactusIllustration: FC = () => (
  <svg
    width="204"
    height="204"
    viewBox="0 0 204 204"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2854_10122)">
      <path
        d="M171.137 54.4978C182.439 54.4978 191.602 45.2637 191.602 33.8729C191.602 22.4821 182.439 13.248 171.137 13.248C159.834 13.248 150.672 22.4821 150.672 33.8729C150.672 45.2637 159.834 54.4978 171.137 54.4978Z"
        fill="#FDC221"
      />
      <path
        d="M143.299 34.9005H139.4C138.477 34.9005 137.729 34.1464 137.729 33.2168C137.729 32.2873 138.477 31.5332 139.4 31.5332H143.299C144.222 31.5332 144.969 32.2873 144.969 33.2168C144.969 34.1464 144.222 34.9005 143.299 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M201.209 34.9005H197.31C196.387 34.9005 195.64 34.1464 195.64 33.2168C195.64 32.2873 196.387 31.5332 197.31 31.5332H201.209C202.132 31.5332 202.879 32.2873 202.879 33.2168C202.879 34.1464 202.132 34.9005 201.209 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M170.304 7.68388C169.381 7.68388 168.634 6.9298 168.634 6.00025V2.07035C168.634 1.14079 169.381 0.386719 170.304 0.386719C171.227 0.386719 171.974 1.14079 171.974 2.07035V6.00025C171.974 6.9298 171.227 7.68388 170.304 7.68388Z"
        fill="#FDC221"
      />
      <path
        d="M143.299 34.9005H139.4C138.477 34.9005 137.729 34.1464 137.729 33.2168C137.729 32.2873 138.477 31.5332 139.4 31.5332H143.299C144.222 31.5332 144.969 32.2873 144.969 33.2168C144.969 34.1464 144.222 34.9005 143.299 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M201.209 34.9005H197.31C196.387 34.9005 195.64 34.1464 195.64 33.2168C195.64 32.2873 196.387 31.5332 197.31 31.5332H201.209C202.132 31.5332 202.879 32.2873 202.879 33.2168C202.879 34.1464 202.132 34.9005 201.209 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M189.401 15.6558C188.973 15.6558 188.546 15.4912 188.219 15.1624C187.568 14.5052 187.568 13.4391 188.219 12.7819L190.977 10.003C191.63 9.34537 192.686 9.34537 193.339 10.003C193.991 10.6601 193.991 11.7263 193.339 12.3835L190.582 15.1624C190.255 15.4912 189.828 15.6558 189.401 15.6558Z"
        fill="#FDC221"
      />
      <path
        d="M148.451 56.9248C148.023 56.9248 147.596 56.7602 147.269 56.4314C146.617 55.7739 146.618 54.7081 147.269 54.0506L150.027 51.272C150.68 50.6152 151.736 50.6148 152.39 51.2724C153.042 51.93 153.041 52.9957 152.39 53.6533L149.632 56.4318C149.306 56.7602 148.879 56.9248 148.451 56.9248Z"
        fill="#FDC221"
      />
      <path
        d="M151.209 15.6558C150.781 15.6558 150.354 15.4912 150.027 15.1624L147.27 12.3835C146.618 11.7263 146.618 10.6601 147.27 10.003C147.923 9.34537 148.98 9.34537 149.633 10.003L152.39 12.7819C153.042 13.4391 153.042 14.5052 152.39 15.1624C152.064 15.4912 151.637 15.6558 151.209 15.6558Z"
        fill="#FDC221"
      />
      <path
        d="M192.158 56.9248C191.731 56.9248 191.304 56.7602 190.977 56.4318L188.22 53.6533C187.568 52.9957 187.567 51.93 188.22 51.2724C188.873 50.6148 189.929 50.6152 190.582 51.272L193.34 54.0506C193.991 54.7081 193.992 55.7739 193.34 56.4314C193.013 56.7602 192.586 56.9248 192.158 56.9248Z"
        fill="#FDC221"
      />
      <path
        d="M170.304 7.68388C169.381 7.68388 168.634 6.9298 168.634 6.00025V2.07035C168.634 1.14079 169.381 0.386719 170.304 0.386719C171.227 0.386719 171.974 1.14079 171.974 2.07035V6.00025C171.974 6.9298 171.227 7.68388 170.304 7.68388Z"
        fill="#FDC221"
      />
      <path
        d="M170.304 65.4339C169.381 65.4339 168.634 64.6798 168.634 63.7503V59.8204C168.634 58.8908 169.381 58.1367 170.304 58.1367C171.227 58.1367 171.974 58.8908 171.974 59.8204V63.7503C171.974 64.6798 171.227 65.4339 170.304 65.4339Z"
        fill="#FDC221"
      />
      <path
        d="M143.299 34.9005H139.4C138.477 34.9005 137.729 34.1464 137.729 33.2168C137.729 32.2873 138.477 31.5332 139.4 31.5332H143.299C144.222 31.5332 144.969 32.2873 144.969 33.2168C144.969 34.1464 144.222 34.9005 143.299 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M201.209 34.9005H197.31C196.387 34.9005 195.64 34.1464 195.64 33.2168C195.64 32.2873 196.387 31.5332 197.31 31.5332H201.209C202.132 31.5332 202.879 32.2873 202.879 33.2168C202.879 34.1464 202.132 34.9005 201.209 34.9005Z"
        fill="#FDC221"
      />
      <path
        d="M176.739 134.19C174.367 134.252 172.54 136.346 172.54 138.737V146.575C172.54 148.409 171.064 149.897 169.244 149.897H168.222V125.969C168.222 122.7 165.592 120.049 162.347 120.049C159.103 120.049 156.473 122.7 156.473 125.969V177.175H168.222V158.59H170.468C176.376 158.59 181.166 153.763 181.166 147.808V138.536C181.166 136.097 179.173 134.127 176.739 134.19Z"
        fill="#EE399E"
      />
      <path
        d="M75.3506 203.584L113.361 172.468C128.496 160.078 150.177 160.078 165.313 172.468L203.323 203.584H75.3506Z"
        fill="#DFA414"
      />
      <path
        d="M0.676758 203.585L50.3617 162.912C70.146 146.717 98.4868 146.717 118.271 162.912L167.956 203.585H0.676758Z"
        fill="#FDC221"
      />
      <path
        d="M82.3659 80.9567C77.4522 81.0473 73.6074 85.296 73.6074 90.2488V108.3C73.6074 111.509 71.0259 114.111 67.8415 114.111H63.2129V71.0756C63.2129 64.4514 57.8849 59.082 51.3123 59.082C44.7397 59.082 39.4117 64.4514 39.4117 71.0756V136.658H34.6453C31.7505 136.658 29.4037 134.293 29.4037 131.376V114.411C29.4037 109.388 25.317 105.325 20.3111 105.418C15.3975 105.508 11.5527 109.757 11.5527 114.71V133.66C11.5527 145.252 20.8768 154.649 32.3788 154.649H38.1552C38.5828 154.649 39 154.608 39.4117 154.55V204H63.2129V132.102H70.6323C82.1343 132.102 91.4584 122.705 91.4584 111.113V89.9504C91.4584 84.9268 87.3718 80.8645 82.3659 80.9567Z"
        fill="#EE399E"
      />
    </g>
    <defs>
      <clipPath id="clip0_2854_10122">
        <rect width="204" height="204" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
